module.exports = __webpack_public_path__ + "img/gift4-01-c07-y1.f94a59b0.png";